import React from 'react';

import { StyleSheet } from 'react-native';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { CardModal } from 'components/card-modal';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { primitive } from 'styles/constants';

import { LoyaltyBadgeDetailsContent } from './loyalty-badge-detail-content';
import { ILoyaltyBadge } from './types';
import { BadgeAnimationSourceResult } from './use-badge-animation-source';
import { useBadgeDetailActions } from './use-badge-detail-actions';

export function BadgeDetailModal({
  badge,
  isLoading,
  showCelebration,
  animationSource,
}: {
  badge?: ILoyaltyBadge;
  isLoading: boolean;
  showCelebration: boolean;
  animationSource?: BadgeAnimationSourceResult;
}) {
  const { handleClose, handleCtaPress, footerButtonLabel } = useBadgeDetailActions(badge);

  const actionButtonStyleProps = badge?.earnedAt
    ? { variant: ActionButtonVariants.OUTLINE }
    : {
        backgroundColor: primitive.$meltyYellow,
        _text: { color: primitive.$bbqBrown },
        _hover: { backgroundColor: primitive.$meltyYellowDark45 },
        _pressed: { backgroundColor: primitive.$meltyYellowDark40 },
        color: primitive.$bbqBrown,
      };

  const footer =
    !isLoading && badge ? (
      <ActionButton
        fullWidth
        accessibilityRole="link"
        onPress={handleCtaPress}
        accessibilityLabel={footerButtonLabel}
        {...actionButtonStyleProps}
      >
        {footerButtonLabel}
      </ActionButton>
    ) : undefined;

  return (
    <CardModal
      alwaysShowHeader
      webAnimate
      scrollView
      standardPadding={!isLoading}
      isLoading={isLoading}
      headerText={isLoading ? undefined : 'Badges'}
      onDismiss={handleClose}
      disableGlobalAppModals={isLoading}
      wrappedChildrenStyle={isLoading ? undefined : styles.wrappedChildrenStyle}
      footer={footer}
    >
      {isLoading || !badge ? (
        <LoyaltyLoader />
      ) : (
        <LoyaltyBadgeDetailsContent
          badge={badge}
          showCelebration={showCelebration}
          animationSource={animationSource}
        />
      )}
    </CardModal>
  );
}

const styles = StyleSheet.create({
  wrappedChildrenStyle: {
    paddingTop: 32,
    paddingHorizontal: 24,
    gap: 32,
    backgroundColor: primitive.$mayoEggWhite,
  },
});
